import { render, staticRenderFns } from "./TestPlanRelationModal.vue?vue&type=template&id=501b5c92&scoped=true"
import script from "./TestPlanRelationModal.vue?vue&type=script&lang=js"
export * from "./TestPlanRelationModal.vue?vue&type=script&lang=js"
import style0 from "./TestPlanRelationModal.vue?vue&type=style&index=0&id=501b5c92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b5c92",
  null
  
)

export default component.exports